import { GeneralState } from './interfaces/general.state';
import { createReducer, on } from '@ngrx/store';
import * as GeneralActions from './general.actions';

const initState: GeneralState = {
  columnGroups: {},
  lang: 'en',
};

export const generalReducers = createReducer(
  initState,
  on(
    GeneralActions.setColumnGroups,
    GeneralActions.getColumnGroupsSuccess,
    (state, { columnGroups }) => ({
    ...state,
    columnGroups,
  })),
  on(GeneralActions.setLang, (state, { lang }) => ({
    ...state,
    ...(lang ? { lang } : {}),
  })),
  on(GeneralActions.clearStore, () => initState),
);
